
// 配置网站支持的语言
const LANGS = {
  'en': 'en',
  'ja': 'ja',
  'zh-cn': 'zh-CN'
}

/**
 * 获取浏览器的语言设置
 * 如果没找到则返回一个默认值 en
 */
export const getLang = () => {
  const lowerLang = (window.navigator.language || 'en').toLowerCase()

  // default: en
  return LANGS[lowerLang] || 'en'
}

/**
 * 设置 html 标签的 lang
 */
export const setHtmlLang = lang => {
  // documentElement 根root HTML
  document.documentElement.setAttribute('lang', lang)
}
